export default __webpack_public_path__ + "static/media/twitter.c9002248.png";